
export const orderStatusList = [
    { id: 'WAIT_BUYER_PAY', name: '下单未支付（待付款）' },
    { id: 'WAIT_SELLER_SEND_GOODS', name: '已付款未发货' },
    { id: 'SELLER_CONSIGNED_PART', name: '淘宝' },
    { id: 'WAIT_BUYER_CONFIRM_PAY', name: '已付款，卖家部分发货' },
    { id: 'TRADE_BUYER_SIGNED', name: '买家已签收（用于货到付款）' },
    { id: 'WAIT_BUYER_CONFIRM_GOODS', name: '已发货未确认（待收货）' },
    { id: 'TRADE_FINISHED', name: '交易成功 （由买家确认收货或系统自动触发）' },
    { id: 'TRADE_CLOSED', name: '交易关闭（付款以前，卖家或买家主动关闭交易，包括平台自动关闭情况）' },
    { id: 'PAID_FORBID_CONSIGN', name: '该状态代表订单已付款但是处于禁止发货状态（例如线上下单线下门店发货）' },
    { id: 'TRADE_CLOSED_ALL_REFUND', name: '全额退款交易关闭' },
    { id: 'TRADE_PAID', name: '订单已支付 ，该状态仅代表当前订单已支付成功，表示瞬时状态，稍后会自动修改成后面的状态。如果不关心此状态请再次请求详情接口获取下一个状态， 仅有赞平台' },
]
export const channelList = [
{ id: 'TAOBAO', name: '淘宝', shopName: '蔓迪官方旗舰店', color: '#FF5000' },
{ id: 'JOS', name: '京东', shopName: '蔓迪官方旗舰店', color: '#E2211C' },
{ id: 'DOUYIN', name: '抖音', shopName: '蔓迪京东自营官方旗舰店', color: '#111111' },
{ id: 'REDBOOK', name: '小红书', shopName: '蔓迪旗舰店', color: '#FF2442' },
]

export function channelFn(state: string, type = 'name') {
    const map = mapListStatus(channelList, 'id', type);
    return map[state]
  }
//格式化时间
export function dateFormat(date: any, format?: string) {
    if (!date) return;
    if (!format) format = "yyyy-MM-dd";
    switch (typeof date) {
        case "string":
            date = new Date(date.replace(/-/, "/"));
            break;
        case "number":
            date = new Date(date);
            break;
        default:
            date = new Date(date);
            break;
    }
    date = new Date(date);
    if (!(date instanceof Date)) return;
    //console.log("**************** time:" + date);
    var dict:any = {
        "yyyy": date.getFullYear(),
        "M": date.getMonth() + 1,
        "d": date.getDate(),
        "H": date.getHours(),
        "m": date.getMinutes(),
        "s": date.getSeconds(),
        "MM": ("" + (date.getMonth() + 101)).substr(1),
        "dd": ("" + (date.getDate() + 100)).substr(1),
        "HH": ("" + (date.getHours() + 100)).substr(1),
        "mm": ("" + (date.getMinutes() + 100)).substr(1),
        "ss": ("" + (date.getSeconds() + 100)).substr(1)
    };
    return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function () {
        return dict[arguments[0]];
    });
}
// 处理服务端返回的日期 2024-05-29T14:28:32
export function disposeServerDateFn(str: string, format = "yyyy-MM-dd HH:mm:ss") {
    if(!str) return '-'
    return dateFormat(new Date(str), format)
}

// 数组转对应枚举
export function mapListStatus(list:any, idField:any, colorField:any) {
return list.reduce((result:any, item:any) => {
    result[item[idField]] = item[colorField];
    return result;
}, {});
}
export function orderStatusFn(state: string, type = 'name') {
const map = mapListStatus(orderStatusList, 'id', type);
return map[state]
}

// 蔓迪星球订单状态
export const mdxqOrderStatusList = [
    { id: 0, name: '待付款' },
    { id: 1, name: '已发货' },
    { id: 2, name: '已签收' },
    { id: 3, name: '拒收' },
    { id: 4, name: '取消' },
]
export function mdxqOrderStatusFn(state: string, type = 'name') {
    const map = mapListStatus(mdxqOrderStatusList, 'id', type);
    return map[state]
}
